/* @flow */
import _ from 'lodash';

import { callApiEndpoint } from './index';

import utils from './utils';

import type {
  TrackSortingField,
  SimplifiedTrack,
  TrackSearchFullParams,
  TrackSearchResultList,
} from '../../types';

const toFieldName = (field: TrackSortingField) => {
  switch (field) {
    case 'title':
      return 'titolo';
    case 'media':
      return 'supportoTitolo';
    case 'authors':
      return 'autori';
    case 'performers':
      return 'interpreti';
    default:
      return undefined;
  }
};

const find = async ({
  text,
  flags = {},
  excludeProductionMusic,
  filters,
  filtersMeta,
  sorting,
  pagination,
}: TrackSearchFullParams): Promise<TrackSearchResultList> => {
  const sort = sorting
    ? {
        fieldName: toFieldName(sorting.field),
        reverse: sorting.order !== 'asc',
      }
    : null;
  const {
    hits: { hits, total },
    aggregations,
  } = await callApiEndpoint('tracce/search', {
    method: 'POST',
    body: {
      //query: text } });
      // {
      query: text || '',
      queryTitolo: flags.title || false,
      queryPeople: flags.people || false,
      queryTags: flags.tags || false,
      titolareId: null,
      supportoId: null,
      titolareType: null,
      excludeProductionMusic: excludeProductionMusic || false,
      categoriaIds: _.get(filters, 'categories') || [],
      categoriaIdsFilter: _.get(filtersMeta, 'categories.filter', null),
      categoriaIdsSize: _.get(filtersMeta, 'categories.pagination', 10),
      interpreti: _.get(filters, 'performers', []),
      interpretiFilter: _.get(filtersMeta, 'performers.filter', null),
      interpretiSize: _.get(filtersMeta, 'performers.pagination', 10),
      autori: _.get(filters, 'authors', []),
      autoriFilter: _.get(filtersMeta, 'authors.filter', null),
      autoriSize: _.get(filtersMeta, 'authors.pagination', 10),
      tags: _.get(filters, 'tags', []),
      tagsFilter: _.get(filtersMeta, 'tags.filter', null),
      tagsSize: _.get(filtersMeta, 'tags.pagination', 8000),
      anni: _.get(filters, 'years', []),
      anniFilter: _.get(filtersMeta, 'years.filter', null),
      anniSize: _.get(filtersMeta, 'years.pagination', 10),
      editori: _.get(filters, 'editors', []),
      editoriFilter: _.get(filtersMeta, 'editors.filter', null),
      editoriSize: _.get(filtersMeta, 'editors.pagination', 10),
      etichette: _.get(filters, 'labels', []),
      etichetteFilter: _.get(filtersMeta, 'labels.filter', null),
      etichetteSize: _.get(filtersMeta, 'labels.pagination', 10),
      produttori: _.get(filters, 'producers', []),
      produttoriFilter: _.get(filtersMeta, 'producers.filter', null),
      produttoriSize: _.get(filtersMeta, 'producers.pagination', 10),
      collectings: _.get(filters, 'collectings', []),
      collectingsFilter: _.get(filtersMeta, 'collectings.filter', null),
      collectingsSize: _.get(filtersMeta, 'collectings.pagination', 10),
      cataloghi: _.get(filters, 'catalogs', []),
      cataloghiFilter: _.get(filtersMeta, 'catalogs.filter', null),
      cataloghiSize: _.get(filtersMeta, 'catalogs.pagination', 10),
      sort,
      ...(pagination || { start: 0, end: 20 }),
    },
  });
  return {
    total,
    hits: hits.map(({ _source }) => utils.toTrack(_source)),
    aggregations: utils.toTrackAggregations(aggregations),
  };
};

const downloadUrl = async (tracks: SimplifiedTrack[]): Promise<String> => {
  const url = await callApiEndpoint('downloadstrategies/getDownloadUrl', {
    method: 'POST',
    body: {
      tracksIds: tracks.map(t => t.id),
      highQualities: true,
    },
  });
  return url.downloadUrl;
};

export default {
  find,
  downloadUrl,
};
